import { ApiResult } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { StatusCodes } from '@e3dc-react/shell/Libs/http-status-codes'
import { handleFetchError } from 'src/Libs/api/utils'
import { OwnerAccessRequestModel, OwnerAccessRequestUpdateActionsType } from '../models'
import { OwnerAccessRequestDto } from '../dto'
import { ownerAccessRequestDtoToModelTransformer } from '../transformer'
import { isFlowTheme } from 'src/Libs/utils'

/**
 * fetch access requests for the installation
 */
export const fetchAccessRequests = async (
  installationId: number,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<OwnerAccessRequestModel[], AuthFetchError | Error>> => {
  if (isFlowTheme) return new ApiResult<OwnerAccessRequestModel[], AuthFetchError | Error>([], false) //TODO remove when Flow supports this feature
  try {
    const response = await authFetch<OwnerAccessRequestDto[]>({
      path: `installations/${installationId}/access-requests`,
      method: 'GET',
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    if (response.status === StatusCodes.OK) {
      const accessRequests = ownerAccessRequestDtoToModelTransformer(response.data)
      return new ApiResult<OwnerAccessRequestModel[], Error | AuthFetchError>(accessRequests)
    }

    return new ApiResult<OwnerAccessRequestModel[], Error | AuthFetchError>(null, true)
  } catch (error) {
    return handleFetchError<OwnerAccessRequestModel[]>(error)
  }
}

/**
 * 'accept'/ 'reject' access request for the installation.
 */
export const updateAccessRequest = async (
  decision: OwnerAccessRequestUpdateActionsType,
  installationId: number,
  accessRequestId: number,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<boolean, AuthFetchError | Error>> => {
  try {
    const response = await authFetch<string>({
      path: `installations/${installationId}/access-requests/${accessRequestId}`,
      method: 'PUT',
      payload: { decision },
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })

    if (response.status === StatusCodes.NO_CONTENT) {
      return new ApiResult<boolean, Error | AuthFetchError>(true)
    }

    return new ApiResult<boolean, Error | AuthFetchError>(null, true)
  } catch (error) {
    return handleFetchError<boolean>(error)
  }
}
